module.exports = __webpack_public_path__ + "img/videoListDefaultCover.6b9ff2a8.jpg";